import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, input, OnDestroy, signal, viewChild } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-animated-height-container',
  imports: [],
  template: `
    <div
      class="height-animation-wrapper"
      [style.height.px]="containerHeight()"
      [class.initialized]="heightInitialized()"
      [class.scrollable]="scrollable()"
      [class.hide-overflow]="hideOverflow()"
      [class.max-height]="maxHeight()"
      #heightWrapper
    >
      <div #heightContent>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrl: './animated-height-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimatedHeightContainerComponent implements AfterViewInit, OnDestroy {
  public maxHeight = input<boolean>(true);
  public hideOverflow = input<boolean>(false);
  public scrollable = signal<boolean>(false);
  public heightWrapper = viewChild<ElementRef>('heightWrapper');
  public heightContent = viewChild<ElementRef>('heightContent');
  public containerHeight = signal<number>(0);
  public heightInitialized = signal<boolean>(false);

  private resizeObserver: ResizeObserver | null = null;

  ngAfterViewInit(): void {
    setTimeout(() => this.initializeResizeObserver(), 0);
  }

  private initializeResizeObserver(): void {
    const contentEl = this.heightContent()?.nativeElement as HTMLElement;
    if (!contentEl) return;

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.scrollable.set(false);
        this.containerHeight.set(entry.contentRect.height);
        setTimeout(() => this.scrollable.set(true), 500);
        if (!this.heightInitialized()) {
          setTimeout(() => {
            this.heightInitialized.set(true);
          }, 1000);
        }
      }
    });

    this.resizeObserver.observe(contentEl);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }
}
